
/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessenger {
    export class IsolateFormDirective implements angular.IDirective {
        require: 'ngForm';

        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, formCtrl: any) => {
            // Break the connection to parent form
            let parentFormCtrl = element.parent().controller('form');
            let childController = scope[`${attrs.name}`];

            if (parentFormCtrl && childController) {
                // Remove this form from parent form's validation
                parentFormCtrl.$removeControl(childController);

                // Watch child form's validity without affecting parent
                scope.$watch(function() {
                    return childController.$valid;
                }, function(validity) {
                    // You can handle child form validity changes here if needed
                    console.log('Child form validity:', validity);
                });
            }
        };

        constructor() { }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new IsolateFormDirective();
            };
            directive.$inject = [];

            return directive;
        }
    }

    angular.module("meevo.plugins.meevoMessenger")
        .directive("isolateForm", IsolateFormDirective.factory());
}
